<template>
  <div id="menu">
    <!-- プロフィール画面 -->
    <transition name="popup">
      <PCProfile
        v-if="state.visibleProfile"
        @closeProfile="state.visibleProfile = false"
      />
    </transition>

    <!-- 詳細検索 -->
    <transition name="popup">
      <PCQASearchDetail
        v-if="state.visibleSearchDetail"
        :startLoading="state.visibleSearchDetail"
        :parentName="'PCMenu'"
        :parentNameOfMenu="menu.parentName"
        @searchDetail="search.searchDetail"
        @closeSearchDetail="state.visibleSearchDetail = false"
        @closeMenu="closeMenu"
      />
    </transition>

    <div class="menu" :style="{'background-image':'url(' + background.image + ')'}">
      <div class="menu-close" role="button" @click="closeMenu">
        <FontawesomeIcon class="icn" :icon="['fal','times']" />
      </div>
      <div class="menu-container" style="min-height:760px;">
        <div class="menu-head">
          <div class="menu-head-item profile border-l ga-profile" role="button" @click="state.visibleProfile = true">
            <span v-if="profile.user_icon > 0" class="image ga-profile" :style="{backgroundImage : 'url(' + profile.user_icon_image + ')'}"></span>
            <span v-else class="image no-image ga-profile">{{profile.name.slice(0, 1)}}</span>
            <span class="name ga-profile">{{profile.name}}</span>
            <FontawesomeIcon :icon="['far','angle-right']" size="2x" class="icn icn-arrow ga-profile" />
          </div>
          <div class="menu-head-item count"
            v-if="!isFromAdminSystem()">
            <a @click.prevent.stop="menu.routerTo('PCAlertList')" role="button"><FontawesomeIcon :icon="['fas','bell']" class="icn mr8" /><span class="circle">{{alert.count_disp}}</span></a>
          </div>
        </div>
        <div class="menu-title">検索</div>
        <form @submit.prevent="search.clickSearch" class="menu-content search" :class="search.gaSearchClass">
          <div class="menu-content-01">
            <div class="formparts select"
              :class="{'is-visible-list': state.isOpenSearchCategory}"
              @mouseenter="state.isOpenSearchCategory = true"
              @mouseleave="state.isOpenSearchCategory = false"
            >
              <div class="select-label" role="select">{{ search.searchCategoryName }}<FontawesomeIcon :icon="state.isOpenSearchCategory ? 'angle-up' : 'angle-down'" class="icn" /></div>
              <div class="select-option">
                <ul class="select-option-list">
                  <li role="option"><label><input type="radio" v-on:change="search.changeCategory" v-model="search.searchCategory" value="qa">Q&amp;A・事例</label></li>
                  <li v-if="!isFromAdminSystem()" role="option"><label><input type="radio" v-on:change="search.changeCategory" v-model="search.searchCategory" value="knowledge">最新ナレッジ</label></li>
                  <li role="option"><label><input type="radio" v-on:change="search.changeCategory" v-model="search.searchCategory" value="book">書籍目次</label></li>
                  <li role="option"><label><input type="radio" v-on:change="search.changeCategory" v-model="search.searchCategory" value="download">書式ダウンロード</label></li>
                  <li v-if="!isFromAdminSystem()" role="option"><label><input type="radio" v-on:change="search.changeCategory" v-model="search.searchCategory" value="note">ノート</label></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="menu-content-02">
            <div class="formparts search">
              <span role="button"><FontawesomeIcon @click="search.clickSearch" :class="search.gaSearchClass" :icon="['far','search']" size="2x" class="icn" /></span>
              <input type="text" 
                v-model="search.keyword_input"
                @input="suggest.keyInput" 
                @compositionend="suggest.keyInput"
                v-click-outside="() => { suggest.displayTip = false }"
                maxlength="50"
                placeholder="キーワードを入力（最大50文字）">
              <div v-show="suggest.displayTip" class="tip">{{ suggest.fixedCount }}</div>
            </div>
          </div>
          <div class="menu-content-03">
            <div class="menu-filter border-l">
              <div class="formparts checkbox">
                <input type="checkbox" id="menu_is_fuzzy"
                  v-model.number="search.is_fuzzy_input"
                  :true-value="0"
                  :false-value="1"
                >
                <label v-if="search.searchCategory !== 'note' && search.searchCategory !== 'download'" 
                role="button" for="menu_is_fuzzy">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
              </div>
            </div>
            <div v-if="search.searchCategory === 'qa'" class="menu-filter">
              <span role="button"
                @click="visibleSearchDetail"
                >詳細検索
              </span>
            </div>
            <template v-if="!isFromAdminSystem()">
              <div 
                v-if="search.searchCategory === 'qa' || search.searchCategory === 'knowledge'"
                class="menu-filter"><a @click.prevent.stop="menu.routerTo('PCSearchConditionList')" role="button">保存検索条件</a></div>
              <div 
                v-if="search.searchCategory === 'qa' || search.searchCategory === 'knowledge' || search.searchCategory === 'note'"
                class="menu-filter"><a @click.prevent.stop="menu.routerTo('PCHistoryOfSearch')" role="button">検索履歴</a></div>
            </template>
          </div>
        </form>
        <div class="menu-title">メニュー</div>
        <div class="menu-content pages">
          <ul class="column gutter row-5">
            <template v-for="(list, index) in menu.general">
              <li :key="'menu_' + index" 
                v-if="menu.isMenuButtonShown(list)"
                class="column-item space-gutter">
                <a @click.prevent="menu.routerTo(list.name)" class="box01" role="button" v-if="list.name !== 'PCDocumentSearch'">
                  <span class="box01-link">{{list.display}}</span>
                </a>
                <a href="/lc/app/document-top/" class="box01" role="button" target="_blank" v-else>
                  <span class="box01-link">
                    {{list.display}}
                    <FontawesomeIcon v-if="list.name === 'PCDocumentSearch'" :icon="['far','external-link']" class="icn ml8" />
                  </span>
                </a>
              </li>
            </template>
          </ul>
        </div>
        <template v-if="!isFromAdminSystem()">
          <div class="menu-title">管理メニュー</div>
          <div class="menu-content license">
            <ul class="column gutter row-5">
              <li v-for="(list, index) in menu.adminMenuList" :key="'menu_' + index" class="column-item space-gutter sm">
                <a @click.prevent.stop="menu.routerTo(list.name)" class="box01" role="button">
                  <span class="box01-link">{{list.display}}</span>
                </a>
              </li>
            </ul>
          </div>
        </template>
        <div class="menu-footer">
          <ul class="menu-footer-list aside-1">
            <li>
              <a @click.prevent.stop="menu.routerTo('PCGuideTop')" role="button">ご利用ガイド</a>
            </li>
          </ul>
          <ul class="menu-footer-list aside-2">
            <li>
              <a href="https://www.sn-hoki.co.jp/guide/social_rules/" target="_blank">利用規約 <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
            </li>
            <li>
              <a href="https://www.sn-hoki.co.jp/privacy/" target="_blank">プライバシーポリシー <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
            </li>
            <li>
              <a href="https://www.sn-hoki.co.jp/guide/tradelaw/" target="_blank">特定商取引法に基づく表示 <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
            </li>
          </ul>
          <p class="copy">Copyright (C) 2021 SHINNIPPON-HOKI PUBLISHING CO.,LTD.</p>
        </div>
      </div>
    </div>
    <iframe style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%; z-index: -1;" src="about:blank"></iframe>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onBeforeMount, onBeforeRouteUpdate } from '@vue/composition-api'
import ClickOutside from 'vue-click-outside'
import PCProfile from '@/components/pc/popup/PCProfile'
import PCQASearchDetail from '@/components/pc/popup/PCQASearchDetail'

import * as logicMenu from '@/logic/Menu'
import { isFromAdminSystem } from '@/util/common'
import { FixedHeader } from '@/logic/qa/FixedScrollHeader'

export default defineComponent({
  name: 'PCMenu',
  components: {
    PCProfile,
    PCQASearchDetail
  },
  directives: {
    ClickOutside
  },
  props: {
    // 呼び出し元の名前
    parentName: {
      type: String,
      default: ''
    }
  },
  setup (props, context) {

    const { suggest, state, alert, profile, menu, background, search, closeMenu } = logicMenu.getGroup(props, context)

    const disableScroll = (e) => {
      e.preventDefault()
    }

    const visibleSearchDetail = () => {

      document.addEventListener('touchmove', disableScroll, { passive: false })
      document.addEventListener('mousewheel', disableScroll, { passive: false })

      state.visibleSearchDetail = true

      setTimeout(() => {
        const fixedTitle = new FixedHeader({
          scroller: '.popup-wrapper',
          target: '.popup-title-fixed',
          wrapper: '.popup-fixed'
        })

        const fixedClose = new FixedHeader({
          scroller: '.popup-wrapper',
          target: '.close-fixed',
          type: 'absolute',
          offset: 12
        })

        document.removeEventListener('touchmove', disableScroll, { passive: false })
        document.removeEventListener('mousewheel', disableScroll, { passive: false })
      }, 500)
    }

    return {
      suggest,
      state,
      alert,
      profile,
      menu,
      background,
      search,
      closeMenu,
      isFromAdminSystem,
      visibleSearchDetail
    }
  }
})
</script>

<style lang="scss" scoped>
  #menu {
    .menu {
      height: 0;
      opacity: .01;
      /*
      transition: all .2s ease;
      */
    }
    &.visible {
      .menu {
        opacity: 1;
        height: 100%;
      }
    }
  }
  .menu {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: $index-menu;
    background-size: cover;
    background-position: center;
    overflow: auto;
    color: #fff;
    a,label {
      color: #fff; 
    }
    a {
      @include hoverOpacity;
    }
    &-close {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
      width: 126px;
      height: 148px;
      border-bottom-left-radius: 8px;
      background-color: $color-link;
      .icn {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 50%;
        top: 24px;
        transform: translate3d(-50%,0,0);
        @include hoverOpacity();
      }
    }
    &-container {
      margin: 40px;
      padding: 40px 40px;
      border-radius: 5px;
      background-color: rgba(0,0,0,.1);
      height: calc(100% - 80px);
      position: relative;
    }
    &-head {
      text-align: right;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 48px;
      &-item {
        display: flex;
        align-items: center;
        padding: 0 38px;
        @include hoverOpacity;
        .image {
          overflow: hidden;
          border-radius: 50%;
          display: block;
          width: 40px;
          height: 40px;
          background-position: center;
          background-size: cover;
          &.no-image {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 2.0rem;
            color: $color-hdg;
            font-weight: bold;
            background-color: $color-no-image;
          }
        }
        .name {
          margin-left: 10px;
        }
        & + & {
          border-left: 1px solid rgba(0,0,0,.1);
        }
        &.count {
          .icn {
            transform: rotate(45deg);
          }
          .circle {
            background-color: #fff;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            color: $color-link;
            font-size: 1.4rem;
          }
        }
      }
      .icn-arrow {
        font-size: 1.6rem;
        margin-left: 20px;
      }
    }
    &-title {
      font-size: 2.0rem;
      color: rgba(255,255,255,.6);
      margin-bottom: 20px;
    }
    &-content {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      .column {
        width: calc(100% + 20px);
        &-item {
          margin-top: 8px;
          margin-bottom: 8px;
          &.sm {
            .box01-link {
              padding: 10px 30px;
            }
          }
        }
      }
      &.search {
        .menu-content-01 {
          width: 200px;
          margin-right: 10px;
          .formparts.select {
            margin-bottom: 0;
            .select-label {
              color: #fff;
            }
            .select-option-list {
              color: $color-content;
            }
          }
        }
        .menu-content-02 {
          width: calc(100% - 750px);
          margin-right: 10px;
          .formparts {
            margin-bottom: 0;
            .icn {
              color: #fff;
            }
            input {
              height: 48px;
              color: #fff;
              -webkit-text-fill-color: #fff !important;
              &::placeholder {
                color: rgba(255,255,255,.6);
              }
            }
          }
        }
        .menu-content-03 {
          width: 550px;
          .formparts {
            margin-bottom: 0;
            &.checkbox label:hover {
              color: #fff;
            }
          }
          .menu-filter {
            display: inline-block;
            padding: 0 10px;
          }
        }
      }
      .formparts.select {
        label {
          color: $color-content;
        }
      }
    }
    &-footer {
      position: absolute;
      right: 40px;
      bottom: 40px;
      text-align: right;
      &-list {
        list-style: none;
        margin-bottom: 16px;
        li {
          display: inline-block;
          & + li {
            margin-left: 36px;
            a {
              @include hoverOpacity();
            }
          }
        }
        &.aside-1 {
          font-size: 1.6rem;
        }
        &.aside-2 {
          font-size: 1.2rem;
        }
      }
      .copy {
        font-size: 1.2rem;
        opacity: .8;
      }
    }
  }

.menu-enter-active,
.menu-leave-active {
  .menu {
    transition: all 2s ease-out;
  }
}
.menu-enter,
.menu-leave-to {
  .menu {
    height: 0;
  }
}
.menu-enter-to,
.menu-leave {
  .menu {
    height: 100%;
  }
}
</style>
